import { extractPaymentStatus } from "./paymentStatus";
import { extractTransactionType } from "./transactionType";

const getCustomerLabel = (tx) => {
  const name = tx.customerName ?? tx.customer_name;
  if (typeof name === "string" && name.trim()) return name.trim();
  const id = tx.customerId ?? tx.customer_id;
  return id ? `לקוח ${id}` : "-";
};

export const flattenTransactionsMap = (byOrderId) => {
  if (!byOrderId || typeof byOrderId !== "object") return [];
  const txs = [];
  for (const list of Object.values(byOrderId)) {
    if (Array.isArray(list)) txs.push(...list);
  }
  return txs;
};

export const transactionsToRows = (transactions) => {
  if (!Array.isArray(transactions)) return [];

  return transactions.map((tx, idx) => {
    const orderId = String(tx.orderId ?? tx.order_id ?? "");
    const payment = tx.payment || {};

    return {
      key: tx.id ?? `${orderId}-${idx}`,
      transactionId: tx.id ?? null,
      orderId,
      customerId: tx.customerId ?? tx.customer_id ?? null,
      customerLabel: getCustomerLabel(tx),
      date: tx.created ?? tx.updated,
      status: extractPaymentStatus(tx),
      transactionType: extractTransactionType(tx),
      sum: tx.sum ?? tx.amount,
      lastFourDigits:
        payment.lastFourDigits ??
        payment.last_four_digits ??
        tx.lastFourDigits ??
        tx.last_four_digits ??
        null,
      transaction: tx,
    };
  });
};

export const sortTransactionRows = (rows) =>
  [...rows].sort(
    (a, b) => new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime(),
  );
